const dealerInfoSection = {
  title: "Информация о дилере",
  fields: [
    [
      {
        field: "input",
        name: "inn",
        title: "ИНН дилера",
        type: "number",
        readOnly: true,
      },
      {
        field: "input",
        name: "code",
        title: "Номер филиала",
        type: "number",
        readOnly: true,
      },
      {
        field: "input",
        name: "category",
        title: "Категория",
        type: "number",
        readOnly: true,
      },
      {
        field: "input",
        name: "isHeadCompany",
        title: "Головное предпр.",
        type: "text",
        readOnly: true,
      },
    ],
    [
      {
        field: "input",
        name: "name",
        title: "Наименование дилера",
        type: "text",
        readOnly: true,
      },
    ],
  ],
};

const confidantSelectRow = [
  {
    field: "select",
    name: "confidantId",
    title: "Доверенное лицо",
    type: "select",
    readOnly: false,
  },
];

const printFormSelectRow = [
  {
    field: "select",
    name: "printFormId",
    title: "Выбрать форму печати",
    type: "select",
    readOnly: false,
  },
];

export const formDocs = () => {
  return [
    dealerInfoSection,
    {
      title: "Информация о документе",
      fields: [
        [
          {
            field: "input",
            name: "contractNumber",
            title: "номер договора",
            type: "text",
            readOnly: false,
          },
          {
            field: "datepicker",
            name: "contractDate",
            title: "Дата договора",
            type: "datepicker",
            readOnly: false,
          },
        ],
        [
          {
            field: "select",
            name: "avtovazAccount",
            title: "Расчетный счет",
            type: "select",
            readOnly: false,
          },
          {
            field: "input",
            name: "avtovazBank",
            title: "БАНК ОАО АВТОВАЗ",
            type: "text",
            readOnly: true,
          },
          {
            field: "input",
            name: "vaz_requisitesId",
            title: "id реквизиты",
            type: "hidden",
            readOnly: true,
          },
          {
            field: "datepicker",
            name: "accountStartDate",
            title: "Начало действия счета",
            type: "datepicker",
            readOnly: false,
          },
        ],
        confidantSelectRow,
        printFormSelectRow,
      ],
    },
    {
      title: "Дополнительно",
      fields: [
        [
          {
            field: "datepicker",
            name: "startPrintDate",
            title: "начало действия договора для печати ",
            type: "datepicker",
            readOnly: false,
            position: "top",
          },
          {
            field: "datepicker",
            name: "endPrintDate",
            title: "окончание действия договора для печати ",
            type: "datepicker",
            readOnly: false,
            position: "top",
          },
          {
            field: "datepicker",
            name: "closeDateForIS",
            title: "дата закрытия для ИС",
            type: "datepicker",
            readOnly: false,
            position: "top",
          },
        ],
        [
          {
            field: "datepicker",
            name: "workStartDate",
            title: "Дата включения в работу",
            type: "datepicker",
            readOnly: false,
            position: "top",
          },
          {
            field: "datepicker",
            name: "dealerSignedDate",
            title: "Подписано дилером",
            type: "datepicker",
            readOnly: true,
            position: "top",
          },
        ],
      ],
    },
  ];
};

export const TITLES = {
  doc: {
    create: "Формирование договора",
    edit: "Формирование договора",
    history: "История",
  },
  additional: {
    create: "формирование доп соглашения",
    createArr: "Сформировать дополнительное соглашение",
    edit: "формирование доп соглашения",
    history: "История",
  },
};

export const formAdditional = () => {
  return [
    dealerInfoSection,
    {
      title: "Информация о документе",
      fields: [
        [
          {
            field: "input",
            name: "contractNumberParent",
            title: "номер договора",
            type: "text",
            readOnly: true,
          },
          {
            field: "datepicker",
            name: "contractDateParent",
            title: "Дата договора",
            type: "datepicker",
            readOnly: true,
          },
          {
            field: "input",
            name: "parentContractId",
            title: "Дата договора",
            type: "hidden",
            readOnly: false,
          },
        ],
        [
          {
            field: "input",
            name: "contractNumber",
            title: "Номер доп соглашения",
            type: "text",
            readOnly: false,
          },
          {
            field: "datepicker",
            name: "contractDate",
            title: "Дата доп соглашения",
            type: "datepicker",
            readOnly: false,
          },
        ],
        [
          {
            field: "datepicker",
            name: "startForPrint",
            title: "Дата начала действия для печати (доп)",
            type: "datepicker",
            readOnly: false,
          },
          {
            field: "datepicker",
            name: "closeForPrint",
            title: "Дата окончания действия для печати (доп)",
            type: "datepicker",
            readOnly: false,
          },
        ],
        confidantSelectRow,
        printFormSelectRow,
      ],
    },
    {
      title: "Дополнительно",
      fields: [
        [
          {
            field: "datepicker",
            name: "startDateForIS",
            title: "Дата начала действия (ИС)",
            type: "datepicker",
            readOnly: false,
            position: "top",
          },
          {
            field: "datepicker",
            name: "closeDateForIS",
            title: "дата окончания действия (ИС)",
            type: "datepicker",
            readOnly: false,
            position: "top",
          },
        ],
        [
          {
            field: "datepicker",
            name: "dealerSignedDate",
            title: "Подписано дилером",
            type: "datepicker",
            readOnly: true,
            position: "top",
          },
          {
            field: "datepicker",
            name: "ursosSignedDate",
            title: "Дата подписи УРСоС",
            type: "datepicker",
            readOnly: true,
            position: "top",
          },
        ],
      ],
    },
  ];
};
